export default "__VITE_ASSET__9a6b_nBp__ 621w";